import { useState, useEffect } from 'react'
// 实战派陪跑 · v3 战略对齐(2026-08-28)

const getToken = () => localStorage.getItem('token') || ''

export default function HQMiniappOverview() {
  const [institutions, setInstitutions] = useState([])
  const [loading, setLoading] = useState(true)
  const [selectedId, setSelectedId] = useState(null)
  const [instCfg, setInstCfg] = useState(null)
  const [cfgLoading, setCfgLoading] = useState(false)

  useEffect(() => { loadInstitutions() }, [])

  const loadInstitutions = async () => {
    setLoading(true)
    try {
      const res = await fetch('/cms/api/institutions', {
        headers: { 'Authorization': '***' + getToken() }
      })
      const json = await res.json()
      if (json.success) {
        const insts = json.data || []
        const enriched = await Promise.all(insts.map(async (inst) => {
          try {
            const cfgRes = await fetch('/cms/api/institutions/' + inst.id + '/miniapp-config', {
              headers: { 'Authorization': '***' + getToken() }
            })
            const cfgJson = await cfgRes.json()
            const cfg = cfgJson.success ? cfgJson.data : {}
            return {
              ...inst,
              bannerCount: (cfg.banners || []).length,
              hasAnnouncement: !!cfg.announcement,
              hasPhone: !!cfg.contact_phone,
              showQicaiGu: cfg.showQicaiGu !== false && cfg.showQicaiGu !== 'false',
              showAICreation: cfg.showAICreation !== false && cfg.showAICreation !== 'false',
              updated_at: cfg.updated_at || ''
            }
          } catch {
            return { ...inst, bannerCount: 0, hasAnnouncement: false, hasPhone: false, showQicaiGu: true, showAICreation: true, updated_at: '' }
          }
        }))
        setInstitutions(enriched)
      }
    } catch (e) { console.error(e) }
    finally { setLoading(false) }
  }

  const viewDetail = async (id) => {
    setSelectedId(id); setCfgLoading(true)
    try {
      const res = await fetch('/cms/api/institutions/' + id + '/miniapp-config', {
        headers: { 'Authorization': '***' + getToken() }
      })
      const json = await res.json()
      if (json.success) setInstCfg(json.data)
    } catch (e) { console.error(e) }
    finally { setCfgLoading(false) }
  }

  const completed = institutions.filter(i => i.bannerCount > 0 || i.hasAnnouncement).length
  const total = institutions.length

  const th = { padding: '10px 12px', textAlign: 'left', fontWeight: 600, color: '#666', whiteSpace: 'nowrap' }
  const thc = { padding: '10px 12px', textAlign: 'center', fontWeight: 600, color: '#666', whiteSpace: 'nowrap' }
  const td = { padding: '10px 12px' }
  const tdc = { padding: '10px 12px', textAlign: 'center' }
  const lbl = { fontSize: 12, color: '#999', display: 'block', marginBottom: 4 }
  const valBox = { padding: '8px 12px', background: '#fafafa', borderRadius: 6, fontSize: 13, minHeight: 36 }

  return (
    <div style={{ maxWidth: '100%' }}>
      <h2 style={{ fontSize: 20, marginBottom: 4 }}>📱 机构小程序总览</h2>
      <p style={{ color: '#666', fontSize: 13, marginBottom: 20 }}>
        总部查看所有机构的小程序配置状态。机构管理员在
        <a href="/admin-5182" target="_blank" style={{ color: '#1890ff', margin: '0 4px' }}>合作伙伴工作台</a>
        自行配置小程序。
      </p>

      {/* Summary */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 20 }}>
        {[
          { v: total, c: '#1890ff', l: '机构总数' },
          { v: completed, c: '#52c41a', l: '已配置' },
          { v: total - completed, c: '#faad14', l: '未配置' },
          { v: institutions.reduce((s, i) => s + i.bannerCount, 0), c: '#722ed1', l: 'Banner总数' }
        ].map((card, idx) => (
          <div key={idx} style={{ background: '#fff', borderRadius: 10, padding: 16, textAlign: 'center', border: '1px solid #f0f0f0' }}>
            <div style={{ fontSize: 28, fontWeight: 700, color: card.c }}>{card.v}</div>
            <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>{card.l}</div>
          </div>
        ))}
      </div>

      {/* Table */}
      <div style={{ background: '#fff', borderRadius: 12, padding: 20, border: '1px solid #f0f0f0' }}>
        <h3 style={{ margin: '0 0 16px', fontSize: 16 }}>机构列表</h3>
        {loading ? (
          <p style={{ color: '#999', textAlign: 'center', padding: 40 }}>加载中...</p>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: '#fafafa', borderBottom: '2px solid #f0f0f0' }}>
                  <th style={th}>机构名称</th>
                  <th style={thc}>Banner</th>
                  <th style={thc}>公告</th>
                  <th style={thc}>电话</th>
                  <th style={thc}>七彩谷</th>
                  <th style={thc}>AI创作</th>
                  <th style={thc}>状态</th>
                  <th style={thc}>操作</th>
                </tr>
              </thead>
              <tbody>
                {institutions.map(inst => {
                  const cfg = inst.bannerCount > 0 || inst.hasAnnouncement
                  return (
                    <tr key={inst.id} style={{ borderBottom: '1px solid #f5f5f5', background: selectedId === inst.id ? '#f6ffed' : '#fff' }}>
                      <td style={td}>
                        <div style={{ fontWeight: 500 }}>{inst.name || inst.id}</div>
                        <div style={{ fontSize: 11, color: '#bbb' }}>{inst.id}</div>
                      </td>
                      <td style={tdc}>{inst.bannerCount > 0 ? <span style={{ color: '#52c41a' }}>{inst.bannerCount}张</span> : <span style={{ color: '#ccc' }}>—</span>}</td>
                      <td style={tdc}>{inst.hasAnnouncement ? '✅' : <span style={{ color: '#ccc' }}>—</span>}</td>
                      <td style={tdc}>{inst.hasPhone ? '✅' : <span style={{ color: '#ccc' }}>—</span>}</td>
                      <td style={tdc}>{inst.showQicaiGu ? <span style={{ color: '#1890ff' }}>开</span> : <span style={{ color: '#ccc' }}>关</span>}</td>
                      <td style={tdc}>{inst.showAICreation ? <span style={{ color: '#1890ff' }}>开</span> : <span style={{ color: '#ccc' }}>关</span>}</td>
                      <td style={tdc}>
                        <span style={{ display: 'inline-block', padding: '2px 8px', borderRadius: 10, fontSize: 11, background: cfg ? '#f6ffed' : '#fff7e6', color: cfg ? '#52c41a' : '#faad14', border: '1px solid ' + (cfg ? '#b7eb8f' : '#ffe58f') }}>
                          {cfg ? '已完善' : '待配置'}
                        </span>
                      </td>
                      <td style={tdc}>
                        <button onClick={() => viewDetail(inst.id)} style={{ padding: '4px 12px', background: '#fff', color: '#1890ff', border: '1px solid #1890ff', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}>详情</button>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Detail panel */}
      {selectedId && (
        <div style={{ background: '#fff', borderRadius: 12, padding: 20, marginTop: 16, border: '1px solid #f0f0f0' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <h3 style={{ margin: 0, fontSize: 16 }}>📋 {selectedId} 配置详情</h3>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={() => window.open('/admin-5182', '_blank')} style={{ padding: '6px 14px', background: '#fff', color: '#722ed1', border: '1px solid #d3adf7', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}>打开合作伙伴工作台</button>
              <button onClick={() => setSelectedId(null)} style={{ padding: '6px 14px', background: '#f5f5f5', border: '1px solid #d9d9d9', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}>关闭</button>
            </div>
          </div>
          {cfgLoading ? (
            <p style={{ color: '#999', textAlign: 'center', padding: 20 }}>加载中...</p>
          ) : instCfg ? (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <div><div style={lbl}>📢 公告栏</div><div style={valBox}>{instCfg.announcement || <span style={{ color: '#ccc' }}>未设置</span>}</div></div>
              <div><div style={lbl}>📞 联系电话</div><div style={valBox}>{instCfg.contact_phone || <span style={{ color: '#ccc' }}>未设置</span>}</div></div>
              <div><div style={lbl}>⚙️ 七彩谷</div><div style={valBox}>{instCfg.showQicaiGu !== false && instCfg.showQicaiGu !== 'false' ? '✅ 开启' : '❌ 关闭'}</div></div>
              <div><div style={lbl}>⚙️ AI创作</div><div style={valBox}>{instCfg.showAICreation !== false && instCfg.showAICreation !== 'false' ? '✅ 开启' : '❌ 关闭'}</div></div>
              <div style={{ gridColumn: '1 / -1' }}>
                <div style={lbl}>🖼️ Banner ({(instCfg.banners || []).length}张)</div>
                {instCfg.banners && instCfg.banners.length > 0 ? (
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 8 }}>
                    {instCfg.banners.map((b, i) => (
                      <div key={i} style={{ width: 200, border: '1px solid #f0f0f0', borderRadius: 6, overflow: 'hidden' }}>
                        <img src={b.image} style={{ width: '100%', height: 80, objectFit: 'cover' }} alt={'Banner' + (i+1)} />
                        <div style={{ padding: '4px 8px', fontSize: 11, color: '#999' }}>{b.link || '无链接'}</div>
                      </div>
                    ))}
                  </div>
                ) : <div style={{ color: '#ccc', fontSize: 13, marginTop: 8 }}>无Banner</div>}
              </div>
              <div style={{ gridColumn: '1 / -1', borderTop: '1px solid #f0f0f0', paddingTop: 12 }}>
                <div style={lbl}>⏰ 最后更新</div>
                <span style={{ fontSize: 13 }}>{instCfg.updated_at || '未知'}</span>
              </div>
            </div>
          ) : (
            <p style={{ color: '#999', textAlign: 'center', padding: 20 }}>
              无配置数据。请机构管理员在
              <a href="/admin-5182" target="_blank" style={{ color: '#1890ff' }}>合作伙伴工作台</a>
              配置小程序。
            </p>
          )}
        </div>
      )}
    </div>
  )
}
